import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  link: {
    textDecoration: "none",
    color: "inherit",
  },
}));
